import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../AuthContext";
import { useTranslation } from 'react-i18next';

const Header = ({title = ''}) => {
  const [ userName, setUserName ] = useState('usuario');
  const { user, session, logout, loading } = useAuth();
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const loggingRef = useRef(false);

  useEffect(() => {
    if (i18n.language !== 'es') {
      i18n.changeLanguage('es');
    }
  }, [i18n]);

  const handleLogout = async () => {
    if (loggingRef.current) return; // prevent multiple rapid triggers
    loggingRef.current = true;

    try {
      await logout('manual');
      // Single navigation, replace to avoid back button returning to an authed page
      navigate('/login', { replace: true });
    } catch(error) {
      console.error('Logout error:', error)
    } finally {
      // re-enable after a short delay in case the user clicks again quickly
      setTimeout(() => { loggingRef.current = false; }, 500);
    }
  };

  useEffect(() => {
    if (user === null) {
      setUserName(t('user.defaultName', 'usuario'));
      return;
    }
    // Email: username del registro. Google: full_name / name.
    const name = user.user_metadata?.username ||
        user.user_metadata?.full_name?.split(' ')[0] ||
        user.user_metadata?.name?.split(' ')[0] ||
        (user.email ? user.email.split('@')[0] : t('user.defaultName', 'usuario'));

    setUserName(name);
  }, [user, t]);

  if (loading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '1rem',
        minHeight: '40px'
      }} />
    );
  }

  return (
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
      <h1 className="dashboard-title upload-title">
        <span style={{ fontWeight: 600 }}>
          Cartola
          <span
            style={{
              background: 'linear-gradient(90deg, #00c4ff, #0094b6)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent'
            }}
          >
            Pro
          </span>
        </span>
        {title && <span style={{ color: '#6b7280' }}> › {title}</span>}
      </h1>
      { session ? (
        <div style={{ fontSize: '0.9rem' }}>
          {t('header.greeting', 'Hola')} { userName } | <span style={{ cursor: 'pointer', textDecoration: 'underline' }} onClick={handleLogout}>{t('nav.logout', 'Cerrar sesión')}</span>
        </div>
      ) : (
        <div style={{ fontSize: '0.9rem' }}>
          <span
            style={{
              cursor: 'pointer',
              textDecoration: 'underline',
              color: '#3b82f6'
            }}
            onClick={() => navigate('/login')}
          >
            {t('nav.login', 'Iniciar sesión')}
          </span>
        </div>
      ) }

    </div>
  );
};

export default Header;
